/** REweb CMS's leading scale: its rich-text editor's Linjeafstand and the text areas' `lineHeight`. */
export const LINE_HEIGHT_SCALE = [
  "1",
  "1.1",
  "1.2",
  "1.35",
  "1.5",
  "1.65",
  "1.8",
  "2",
];

/** The text areas' earlier scale; stored values keep drawing. */
export const EARLIER_LINE_HEIGHTS = ["1.15", "1.25", "1.4", "1.7"];

/** Rich text keeps the scale and any number or length older text already carries (pasted, or from the old editor). */
export function richTextLineHeight(value: string): string | undefined {
  return LINE_HEIGHT_SCALE.includes(value) ||
    /^(?:\d+(?:\.\d+)?(?:px|rem|em|%)?|normal)$/.test(value)
    ? value
    : undefined;
}
